import { Provider } from '@angular/core';
import { CalGtmService } from '@cal-analytics/gtm';
import { GtmGenericDialogsService } from './gtm-generic-dialogs.service';

export const provideGtmGenericDialogsService = (): Provider[] => {
  return [
    {
      provide: GtmGenericDialogsService,
      useFactory: () => {
        return new GtmGenericDialogsService();
      }
    },
    {
      provide: CalGtmService,
      useExisting: GtmGenericDialogsService // Use the same instance as GtmGenericDialogsService
    }
  ];
};
